// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import CiqlerDetail from './Ciqler/CiqlerDetail';
import CanvasBrewDetail from './CanvasBrew/CanvasBrewDetail';
import DriveGuardDetail from './DriveGuard/DriveGuardDetail'
import GroNutruiDetail from './GroNutrui/GroNutruiDetail'
import ReportingToolDetail from './ReportingTool/ReportingToolDetail'
import SousChefDetail from './SousChef/SousChefDetail'
// Import other project detail components as needed

function Main() {
  return (
      <div className="app">
        <nav className="navbar">
          <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
            <h1>Ziad Aly</h1>
          </Link>
        </nav>

        <section id="portfolio">
          <div className="video-grid">
            <Link to="/ciqler" className="project-link" style={{ textDecoration: "none", color: "inherit" }}>
              <div className="project">
                <h3>Ciqler</h3>
                <div className='projectImageMainc'>
              <img src={`${process.env.PUBLIC_URL}/Ciqler_logo.png`}></img>
                </div>
                <div className='attentionGetter'>
                  <p>The Gift: Search Engine</p>
                </div>
                <video autoPlay muted loop controls width="100%" src="./ciqler_engine_for_gifts.mp4" />

              </div>
            </Link>
            <Link to="/canvasbrew" className="project-link" style={{ textDecoration: "none", color: "inherit" }}>
              <div className="project">
                <h3>CanvasBrew</h3>
                <div className='projectImageMain'>
              <img src={`${process.env.PUBLIC_URL}/canvasbrew.png`}></img>
                </div>
                <div className='attentionGetter'>
                  <p>Financial Data: From XLSX to PPTX</p>
                </div>
                <video autoPlay muted loop controls width="100%" src="./CanvasBrew.mp4" />

                {/* <p>One-stop solution to replace existing manual workflows and automate the Excel template to PowerPoint process</p> */}
              </div>
            </Link>
            <Link to="/reportingtool" className="project-link" style={{ textDecoration: "none", color: "inherit" }}>
              <div className="project">
                <h3>Reportingtool</h3>
                <div className="projectImageMainh">
              < img
                src={`${process.env.PUBLIC_URL}/homzmart.png`}
                alt="Reporting Tool project"
              />
            </div>
            <div className='attentionGetter'>
                <p>Real Time KPIs</p>
                </div>
                <video autoPlay muted loop controls width="100%" src="./homzmart_|_data_tool (720p).mp4" />
              </div>
            </Link>
            <Link to="/gronuturi" className="project-link" style={{ textDecoration: "none", color: "inherit" }}>
              <div className="project">
                <h3>Gronuturi</h3>
                <div className='projectImageMaing'>
              <img src={`${process.env.PUBLIC_URL}/gronutri.png`}></img>
                </div>
                <div className='attentionGetter'>
                <p>AR Grocery Shopping Assistant</p>
                </div>
                <video autoPlay muted loop controls width="100%" src="./GroNatur.mp4" />

                {/* <p>AR Grocery Shopping Assistant</p> */}
              </div>
            </Link>
            <Link to="/driveguard" className="project-link" style={{ textDecoration: "none", color: "inherit" }}>
              <div className="project">
                <h3>Driveguard</h3>
                <div className='projectImageMaind'>
              <img src={`${process.env.PUBLIC_URL}/DriveGuradlogo.jpeg`}></img>
                </div>
                <div className='attentionGetter'>
                <p>Driver Fatigue Detection</p>
                </div>
                <video autoPlay muted loop controls width="100%" src="./DriveGuard.mp4" />

                {/* <p>Driver Fatigue detection</p> */}
              </div>
            </Link>
            <Link to="/souschef" className="project-link" style={{ textDecoration: "none", color: "inherit" }}>
              <div className="project">
                <h3>Souschef</h3>
              <div className='projectImageMains'>
              <img src={`${process.env.PUBLIC_URL}/SousChefLogo.jpeg`}></img>
                </div>
                <div className='attentionGetter'>
                <p>LLM Based Chef Assistant</p>
                </div>
                <video autoPlay muted loop controls width="100%" src="./SousChef.mp4" />

              </div>
            </Link>
          </div>
        </section> 

      </div>
  );
}

export default Main;
